export const PROJECT_STATUS = {
  DocumentUpload: "Document Upload",
  EvidenceBase: "Evidence Base",
  InProgress: "In Progress",
  Complete: "Complete",
} as const;

export type ProjectStatus = (typeof PROJECT_STATUS)[keyof typeof PROJECT_STATUS];

export const isPreEvidenceBase = (status: string | null | undefined): boolean =>
  status === PROJECT_STATUS.DocumentUpload || !status;
